/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useRef, useEffect } from "react";
import Cookies from "js-cookie";
import Api from "../../../../services/ServiceApi";
import { Collapse, Image } from "antd";
import Skeleton from "react-loading-skeleton";
import { FormatDateTime } from "../../../utility/format";
import { useDispatch } from "react-redux";
import { setJobExclusions } from "../../../../actions/jobDetailAction";
const content = {
  title: "Exclusion Record",
  reason: "",
  remark: "",
  date: "25/10/2020",
  time: "15.35",
  updateby: "วัฒนพงษ์ นามสกุลอะไรว๊า",
  photo: [],
};

const { Panel } = Collapse;
export default function Exclusion({
  CompanyId,
  OperatorId,
  ProjectId,
  headerdata,
  language,
  factupdate,
  jobData,
}) {
  const dispatch = useDispatch();
  const locale = Cookies.get("locale");
  const [ExclutionRecord, setExclutionRecord] = useState([]);
  const [fetchSuccess, setfetchSuccess] = useState(false);
  const unmounted = useRef(false);
  useEffect(() => {
    Api.post("job_detail/get_jobExclusion_List", {
      company_id: CompanyId,
      operator_id: OperatorId,
      project_id: ProjectId,
      job_id: headerdata?.job_id,
    }).then((res) => {
      if (res.data.result.code === "P") {
        setExclutionRecord(res.data.data.jobExclusion);
        dispatch(setJobExclusions(res.data.data.jobExclusion));
        setTimeout(() => {
          setfetchSuccess(true);
        }, 3000);
      }
    });
    return () => {
      unmounted.current = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Collapse expandIconPosition="right" defaultActiveKey={["1"]}>
        <Panel
          header={
            <>
              <h4>{content.title}</h4>
            </>
          }
          key="1"
        >
          {fetchSuccess ? (
            <div className="d-flex align-content-md-start flex-wrap w-100">
              {ExclutionRecord && ExclutionRecord.length > 0 ? (
                ExclutionRecord.map((data, index) => (
                  <>
                    <div
                      className="col col-12"
                      style={{
                        borderBottom: "1px solid #00000020",
                        padding: "10px 5px",
                      }}
                    >
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          Request date
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          <FormatDateTime
                            text={data.create_date}
                          ></FormatDateTime>
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          {factupdate ? language[locale]["type"] : `-`}
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.service_ma_reason_type}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          {factupdate ? language[locale]["remark"] : `-`}
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.service_ma_reason_desc}
                        </span>
                      </div>
                      <div className="row">
                        <span className="col-12 col-sm-4 content-label">
                          Exclusion Status
                        </span>
                        <span className="col-12 col-sm-8 content-text">
                          {data.exclusion_status || "Waiting"}
                        </span>
                      </div>
                      {data.exclusion_status && (
                        <div className="row">
                          <span className="col-12 col-sm-4 content-label">
                            {data.exclusion_status} Remark
                          </span>
                          <span className="col-12 col-sm-8 content-text">
                            {data.exclusion_result}
                          </span>
                        </div>
                      )}
                    </div>
                  </>
                ))
              ) : (
                <div className="row">
                  <span className="col-12 content-text">
                    ไม่พบข้อมูลการขอ Exclution
                  </span>
                </div>
              )}
              <div className="col col-12" style={{ padding: "10px 5px" }}>
                <div className="row">
                  {/* <span className="col-12 col-sm-4 content-label">Image</span> */}
                  <div className="col-12">
                    <Image.PreviewGroup>
                      {jobData.result_oper_job_pic
                        ?.filter((f) => f.pic_type === "E")
                        .map((data, index) => {
                          return (
                            <Image
                              width={150}
                              height={80}
                              key={`img_index_${index}`}
                              src={Api.checkPath(
                                data.pic_url_path,
                                data.pic_upload_name
                              )}
                            />
                          );
                        })}
                    </Image.PreviewGroup>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <Skeleton height={400}></Skeleton>
          )}
        </Panel>
      </Collapse>
    </>
  );
}
